import Checkbox from "../../../basic/Checkbox";
import { StyleSheet, color, css, font, spacing } from "../../../../styles/theme";
export var ROW_HEIGHT = 48;
export var CELL_PADDING = 11;
export var LINE_HEIGHT = ROW_HEIGHT - 2 * CELL_PADDING;
export default StyleSheet.create({
  tableWrapper: {
    overflow: 'hidden',
    borderBottom: "1px solid ".concat(color.divider)
  },
  fixedTable: {
    top: 0,
    position: 'relative'
  },
  table: {
    tableLayout: 'fixed',
    minWidth: '100%'
  },
  tableHeader: {
    cursor: 'default',
    borderBottom: "1px solid ".concat(color.divider)
  },
  tableHeaderCell: {
    userSelect: 'none',
    color: color.secondaryText,
    fontWeight: 'normal'
  },
  tableBodyWrapper: {
    overflowX: 'hidden'
  },
  tableRow: {
    ':hover': {
      backgroundColor: color.bgGray
    },
    ':active': {
      backgroundColor: color.bgGray
    }
  },
  tableCell: {
    fontSize: font.sm,
    lineHeight: "".concat(LINE_HEIGHT, "px"),
    padding: "".concat(CELL_PADDING, "px")
  },
  expandRow: {
    'background': color.bgPaper,
    ':hover': {
      background: color.bgPaper
    }
  },
  expandCell: {
    padding: spacing.md
  }
});